import React, { Component, Fragment } from 'react';

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { onErrorMsg } from '../../actions/FlashMessage/FlashMessages';
import { setPageTitle } from '../../actions/Page/PageAction';
import { fetchPreviewUser, getAssociationSpecialty } from '../../actions/Users/UserAction';

import { ASSOCIATION_USER, REPORT_USER, SPECIALTY_USER, SUPER_USER } from '../../actionTypes/Users/UserActionType';
import Api from '../../Api';
import Constants from '../../Constants';
import { CasOrgsTabel, CasTable, Loading } from '../Common';
import AdminUserMenu from './components/AdminUserMenu';
import CancelInvite from './components/CancelInvite';
import { canRemoveUserRole } from '../../utils/permissions';
import withLocation from '../HOC/WithLocation';
class UserDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resend: false,
    };
  }

  getUserData() {
    const { previewUser } = this.props;
    return previewUser || {};
  }

  async componentDidMount() {
    const loggedAs = this.props.loggedUserDetails.userRole;
    if (loggedAs === REPORT_USER) {
      this.props.navigate('/settings');
      return;
    }

    window.scrollTo(0, 0);
    this.props.setPageTitle('User Details');
    const queryParams = new URLSearchParams(this.props.location.search);
    const guid = queryParams.get('guid');
    if (guid !== this.getUserData().guid) {
      this.props.fetchPreviewUser(guid);
    }
    this.props.getAssociationSpecialty();
  }

  componentWillUnmount() {
    this.props.setPageTitle();
  }

  resend = async () => {
    if (this.state.resend) {
      return null;
    }
    const url = Constants.apiUrls.userDetails + this.getUserData().id + '/resend';
    try {
      const resp = await Api.instance.putData(url);
      if (!resp.success) {
        throw resp.error;
      }
      this.setState({ resend: true });
    } catch (err) {
      this.props.onErrorMsg(err.response?.data?.error);
    }
  };

  hasDataLoad() {
    const data = new URLSearchParams(this.props.location.search);
    const guid = this.getUserData().guid;
    return this.getUserData().guid === data.get('guid');
  }

  render() {
    const hasLoaded = this.hasDataLoad();
    const user = { ...this.getUserData() };
    const loggedUserRole = this.props.loggedUserDetails.userRole;
    const previewUserRole = user.userRoleConstant;
    console.log('Logged User Role: ', loggedUserRole);
    console.log('Preview User Role: ', previewUserRole);
    const isSpecialtyOrOrg = previewUserRole == SPECIALTY_USER ? 'Specialty' : 'Organization';
    return (
      <div tabIndex={-1} className={`user-details-page init-focus__hidden`}>
        <div className={`mobile_margin`}>
          {hasLoaded ? null : <Loading show />}

          {hasLoaded ? (
            <div className={``}>
              <div className="text-left anchorParent absolute" style={{ zIndex: '99' }}>
                <Link to="/users" className="anchor fontSm-15 lsn-primary-color" label="Back to Users">
                  {' '}
                  <i className="fal fa-arrow-left lsn-primary-color mRight-5" />
                  Back to Users
                </Link>
              </div>
              <div className={'relative margin-center'} style={{ textAlign: 'center' }}>
                <h1 className="form-title-center inline-block" id="app_page_title" tabIndex="0">
                  {user.givenName} {user.familyName}
                </h1>
                <AdminUserMenu history={this.props.navigate} />
              </div>
            </div>
          ) : null}
          {hasLoaded && (
            <div className="details-dashboard" aria-live="polite" tabIndex="0">
              <h2>User information</h2>

              <div className="form-line">
                <label className="left-col">Email</label>
                <span className="right-col">{user.email}</span>
              </div>

              <div>
                <div className="form-line" style={{ margin: '0' }}>
                  <label className="left-col">Status</label>
                  <span className="right-col">{user.status}</span>
                </div>
                {/* Andy: Make a separated component */}
                {user.source === 'I' && canRemoveUserRole(loggedUserRole, previewUserRole) && (
                  <div className="form-line mTop-5-important">
                    <label className="left-col" />
                    <div className="right-col">
                      <button
                        onClick={this.resend}
                        tabIndex={this.state.resend ? -1 : 0}
                        aria-label={this.state.resend ? 'Invite Sent! unavailable' : 'Resend Invite'}
                        className={`btn ${
                          this.state.resend ? 'resent-invite-clicked-btn right-tick' : 'btn-default resent-invite-btn'
                        } `}>
                        {!this.state.resend ? (
                          <Fragment>
                            <i className="fal fa-sync-alt lsn-primary-color mRight-5" />
                            Resend Invite
                          </Fragment>
                        ) : (
                          <Fragment>
                            <i className="far fa-check-circle" /> Invite Sent!
                          </Fragment>
                        )}
                      </button>
                      <CancelInvite userId={user.id} />
                    </div>
                  </div>
                )}
              </div>
              <div className="form-line">
                <label className="left-col">Role</label>
                <span className="right-col">{user.userRole}</span>
              </div>
              {user.userRoleConstant === ASSOCIATION_USER && (
                <Fragment>
                  <div className={'mTop-45'}>
                    <h2>CAS information</h2>
                    <p className="fontSm-15">The following CAS are being used to build dashboards for this user.</p>
                  </div>
                  <CasTable casOrganizations={user.casOrgs} />
                </Fragment>
              )}
              {!user.disabled && ![SUPER_USER, ASSOCIATION_USER].includes(user.userRoleConstant) && (
                <div className={'mBottom-30'}>
                  <div className="form-line">
                    <label className="left-col">
                      {previewUserRole == SPECIALTY_USER ? 'Association' : 'Institution'}
                    </label>
                    {user.institution && <span className="right-col">{user.institution.name}</span>}
                  </div>
                  <div className={'mTop-45'}>
                    <h2>{`CAS and ${isSpecialtyOrOrg} information`}</h2>
                    <p className="fontSm-15">
                      {`The following ${isSpecialtyOrOrg} are being used to build dashboards for this user.`}
                    </p>
                  </div>
                  <CasOrgsTabel isSpecialtyOrOrg={isSpecialtyOrOrg} casOrganizations={user.casOrgs} />
                  <div></div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    previewUser: state.Users.previewUser,
    loggedUserDetails: state.AppSession.userDetails,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onErrorMsg,
      fetchPreviewUser,
      setPageTitle,
      getAssociationSpecialty,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(withLocation(UserDetails));
